export const en = {
  code: 'en',
  wordmark: { main: 'DELUXE', sub: 'ENTERPRISE', reversed: false },
  nav: {
    home: 'Home',
    services: 'Services',
    about: 'About',
    seasonal: 'Seasonal',
    contact: 'Contact',
    getQuote: 'GET A QUOTE',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
  },
  hero: {
    eyebrow: 'RESIDENTIAL PROPERTY SERVICES',
    line1: 'YOUR PROPERTY.',
    line2: 'DONE DELUXE.',
    sub: 'Professional landscaping, lawn care, and seasonal property services for homeowners in Montreal, Laval, the North Shore, and the Laurentians.',
    ctaPrimary: 'GET A FREE QUOTE',
    ctaSecondary: 'EXPLORE SERVICES',
    strip: 'Lawn Care • Landscaping • Seasonal Property Care',
    alt: 'Modern Quebec home with a freshly maintained lawn and landscaped yard at dusk',
    scroll: 'Scroll',
  },
  values: {
    items: [
      { title: 'PROFESSIONAL', text: 'Careful work focused on the details.' },
      { title: 'CONVENIENT', text: 'Put the property work back on our list, not yours.' },
      { title: 'SEASONAL', text: 'Services built around the changing needs of your property.' },
      { title: 'LOCAL', text: 'Serving homeowners in Montreal, Laval, the North Shore, and the Laurentians.' },
    ],
  },
  marquee: ['LAWN CARE', 'LANDSCAPING', 'GUTTER CLEANING', 'WINDOW CLEANING', 'BIN CLEANING', 'SEASONAL PROPERTY CARE', 'YOUR PROPERTY. DONE DELUXE.'],
  services: {
    eyebrow: 'SERVICES',
    heading: 'THE WORK YOUR PROPERTY NEEDS.',
    sub: 'From regular lawn care to the seasonal jobs homeowners would rather leave to someone else, DELUXE handles the work.',
    learnMore: 'LEARN MORE',
    includes: 'What the service can include',
    scopeNote: 'Every property is different — the exact scope is confirmed with your quote.',
    requestQuote: 'REQUEST A QUOTE',
    beforeAfter: { before: 'BEFORE', after: 'AFTER', hint: 'Drag to compare' },
    dual: ['TRIMMED', 'WRAPPED FOR WINTER'],
    pageSub: 'Six practical services for homeowners, delivered with the same standard: careful work, clear communication, and a property that looks looked-after.',
    items: [
      {
        id: 'lawn-care',
        short: 'Lawn Care',
        name: 'LAWN CARE',
        desc: 'Keep your lawn looking clean, healthy, and maintained throughout the season.',
        includes: ['Lawn mowing', 'Trimming', 'Edging', 'General lawn maintenance'],
        img: 'lawn',
        alt: 'A residential lawn before (overgrown) and after (freshly mowed with clean stripes) — drag to compare',
      },
      {
        id: 'landscaping-yard-maintenance',
        short: 'Landscaping & Yard Maintenance',
        name: 'LANDSCAPING & YARD MAINTENANCE',
        desc: 'Keep the rest of your outdoor space looking as cared for as the lawn.',
        includes: ['General yard maintenance', 'Outdoor cleanup', 'Landscaping maintenance', 'Property touch-ups'],
        img: 'landscaping',
        alt: 'Landscaped garden path beside a well-kept residential yard',
      },
      {
        id: 'gutter-cleaning',
        short: 'Gutter Cleaning',
        name: 'GUTTER CLEANING',
        desc: 'Clear seasonal buildup and keep your gutters maintained.',
        includes: ['Seasonal gutter clearing', 'Debris removal', 'Downspout check'],
        img: 'gutter',
        alt: 'A gutter before (clogged with leaves) and after (cleared clean) seen from the rooftop — drag to compare',
      },
      {
        id: 'window-cleaning',
        short: 'Window Cleaning',
        name: 'WINDOW CLEANING',
        desc: 'A cleaner exterior starts with the details homeowners notice every day.',
        includes: ['Exterior window cleaning', 'Detail work', 'Seasonal cleanings'],
        img: 'window',
        alt: 'Large modern windows before (smudged and dusty) and after (professionally cleaned) — drag to compare',
      },
      {
        id: 'bin-cleaning',
        short: 'Garbage Bin Cleaning',
        name: 'GARBAGE BIN CLEANING',
        desc: 'A simple service for one of the jobs nobody wants to deal with.',
        includes: ['Bin washing', 'Deodorizing', 'Seasonal cleanups'],
        img: 'bins',
        alt: 'The same residential waste bins before (dirty) and after (professionally cleaned) — drag to compare',
      },
      {
        id: 'seasonal-care',
        short: 'Seasonal Property Care',
        name: 'SEASONAL PROPERTY CARE',
        desc: 'As the seasons change, so does what your property needs.',
        includes: ['Spring cleanup', 'Fall cleanup', 'Seasonal preparation'],
        img: 'seasonal',
        alt: 'Freshly trimmed cedar hedges along a residential front yard',
        altWinter: 'The same hedges wrapped in burlap for the Quebec winter',
      },
    ],
  },
  yardSeasonal: {
    eyebrow: 'SEASONAL YARD OPENING & CLOSING',
    heading: 'WE OPEN IT. WE CLOSE IT.',
    intro: 'Two connected services that bookend your outdoor season: DELUXE prepares your yard when spring arrives, and puts it properly to rest before winter.',
    springTag: 'SPRING / SUMMER',
    fallTag: 'FALL / WINTER',
    openingAlt: 'A DELUXE worker setting up patio furniture in a clean backyard prepared for spring and summer',
    closingAlt: 'A DELUXE worker covering patio furniture in a tidy backyard prepared for winter',
    opening: {
      name: 'YARD OPENING',
      desc: 'After winter, your property needs a proper reset. DELUXE prepares your yard and outdoor spaces for the spring and summer season.',
      includes: ['Removing winter debris, leaves, branches, and accumulated dirt', 'General spring yard cleanup', 'Preparing lawns and outdoor areas for the new season', 'Cleaning and organizing patios and outdoor spaces', 'Putting outdoor furniture back in place', 'General property cleanup and preparation'],
    },
    closing: {
      name: 'YARD CLOSING',
      desc: 'Before the cold arrives, DELUXE makes sure your property is clean, organized, and ready for the colder months.',
      includes: ['Fall leaf and debris cleanup', 'Final seasonal yard cleanup', 'Preparing outdoor areas for winter', 'Moving or storing outdoor furniture', 'Cleaning patios and exterior areas', 'Organizing the yard before snowfall', 'General winter preparation'],
    },
    ctaHeading: 'GET YOUR PROPERTY READY FOR THE SEASON',
    cta: 'REQUEST A QUOTE',
  },
  featured: {
    eyebrow: 'LAWN CARE',
    line1: 'YOUR YARD.',
    line2: 'WITHOUT THE WORK.',
    body: 'A clean property takes consistent attention. DELUXE handles the regular work so you can spend your time doing something else.',
    cta: 'GET A QUOTE',
    alt: 'Suburban home with a freshly mowed, healthy front lawn',
  },
  philosophy: {
    eyebrow: 'THE DELUXE WAY',
    line1: 'WE HANDLE',
    line2: 'THE WORK.',
    body: "DELUXE is built around a simple idea: property maintenance shouldn't have to take over your free time.",
    points: [
      { n: '01', title: 'SHOW UP', text: "Reliable service starts with doing what you said you'd do." },
      { n: '02', title: 'DO THE WORK', text: 'We focus on practical property services homeowners actually need.' },
      { n: '03', title: 'LEAVE IT BETTER', text: 'Attention to the small details matters.' },
    ],
  },
  how: {
    eyebrow: 'HOW IT WORKS',
    heading: 'GET STARTED WITHOUT THE HASSLE.',
    steps: [
      { n: '01', title: 'REQUEST', text: 'Tell us what your property needs.' },
      { n: '02', title: 'PLAN', text: "We'll review the job and determine the appropriate service." },
      { n: '03', title: 'DELUXE', text: 'We handle the work.' },
    ],
  },
  seasonal: {
    eyebrow: 'SEASONAL SERVICES',
    line1: 'ONE PROPERTY.',
    line2: 'EVERY SEASON.',
    intro: "Your property's needs change throughout the year. DELUXE is being built around seasonal property care, giving homeowners one place to turn as the seasons change.",
    cta: 'SEE SEASONAL SERVICES',
    possible: 'Possible services',
    seasons: [
      { id: 'spring', name: 'SPRING', text: 'Get the property ready for the season.', items: ['Yard cleanup', 'Lawn maintenance', 'Outdoor property preparation'], img: 'spring', alt: 'Spring garden beds coming back to life' },
      { id: 'summer', name: 'SUMMER', text: 'Keep the property looking its best.', items: ['Lawn care', 'Trimming', 'Yard maintenance', 'Exterior services'], img: 'summer', alt: 'Sunlit green lawn at the height of summer' },
      { id: 'fall', name: 'FALL', text: 'Take care of the seasonal buildup before winter.', items: ['Leaf cleanup', 'Yard cleanup', 'Gutter cleaning', 'Winter preparation'], img: 'fall', alt: 'Autumn leaves covering a residential yard' },
      { id: 'winter', name: 'WINTER', text: 'Seasonal services will continue to expand as DELUXE grows.', items: [], img: 'winter', alt: 'Quebec residential street in winter snow', note: 'DELUXE is designed to become an all-season property-care company. Winter offerings will be announced as they are added.' },
    ],
  },
  recurring: {
    eyebrow: 'RECURRING SERVICE',
    heading: 'KEEP IT LOOKING DELUXE.',
    body: 'Regular maintenance keeps the work from piling up and helps your property stay looking its best throughout the season.',
    cta: 'ASK ABOUT RECURRING SERVICE',
    alt: 'Well-maintained home exterior with a clean driveway and lawn',
  },
  aboutHome: {
    eyebrow: 'ABOUT DELUXE',
    heading: 'BUILT TO DO THE WORK RIGHT.',
    body: "DELUXE is a local property-services business built around a simple idea: homeowners shouldn't have to spend their free time worrying about the work around their property.",
    cta: 'MORE ABOUT DELUXE',
  },
  brand: {
    line1: 'NOT JUST',
    line2: 'MAINTENANCE.',
    line3: 'PROPERTY CARE.',
    sub: 'A better way to take care of the work around your home.',
    alt: 'Premium residential property photographed at twilight',
  },
  faq: {
    eyebrow: 'FAQ',
    heading: 'QUESTIONS, ANSWERED.',
    items: [
      { q: 'What services does DELUXE offer?', a: 'DELUXE currently offers lawn care, landscaping and yard maintenance, gutter cleaning, window cleaning, garbage bin cleaning, seasonal property care, and seasonal yard opening and closing for residential properties.' },
      { q: 'Do you offer recurring service?', a: "Recurring service can be discussed depending on your property and the service you need. Mention it in your quote request and we'll go over the options together." },
      { q: 'Do you work with homeowners?', a: 'Yes. DELUXE is primarily focused on residential properties and the homeowners who look after them.' },
      { q: 'How do I request a quote?', a: "Use the quote form on the contact page, or reach out to DELUXE directly. Tell us what your property needs and we'll get back to you." },
      { q: 'Do you operate year-round?', a: 'DELUXE is being built around seasonal property services, so offerings vary throughout the year as the seasons change.' },
      { q: 'What areas do you serve?', a: "DELUXE currently serves homeowners in Montreal, Laval, the North Shore, and the Laurentians. Send a quote request with your address and we'll confirm availability for your property." },
    ],
  },
  finalCta: {
    line1: 'YOUR PROPERTY',
    line2: 'DESERVES THE',
    line3: 'DELUXE TREATMENT.',
    sub: "Let's take care of the work.",
    cta: 'GET A FREE QUOTE',
  },
  area: {
    eyebrow: 'SERVICE AREA',
    line1: 'LOCAL SERVICE.',
    line2: 'PERSONAL APPROACH.',
    body: 'DELUXE serves homeowners in Montreal, Laval, the North Shore, and the Laurentians — and continues to grow its local service area as the company grows.',
  },
  contactPage: {
    line1: "LET'S TALK",
    line2: 'ABOUT YOUR PROPERTY.',
    sub: "Tell us what you need and we'll get back to you about your project.",
    infoEyebrow: 'CONTACT',
    infoHeading: 'READY TO GET STARTED?',
    infoBody: "Tell us what your property needs and let's get the work off your list.",
    phone: 'Phone',
    phoneEnLabel: 'English line',
    phoneFrLabel: 'French line',
    phoneEn: '438-377-0205',
    phoneFr: '438-459-3983',
    email: 'Email',
    emailValue: 'deluxeentretien@gmail.com',
    areaLabel: 'Service Area',
    areaValue: 'Montreal • Laval • North Shore • Laurentians',
    followUs: 'FOLLOW ALONG',
    note: 'Every request is reviewed personally. The more detail you share, the better we can prepare your quote.',
    alt: 'Warm residential home exterior in the early evening',
  },
  form: {
    firstName: 'First Name',
    lastName: 'Last Name',
    phone: 'Phone',
    email: 'Email',
    address: 'Property Address',
    service: 'Service',
    frequency: 'Frequency',
    message: 'Message',
    messagePlaceholder: 'Tell us a little about what you need.',
    submit: 'REQUEST A FREE QUOTE',
    submitting: 'SENDING…',
    required: 'required',
    errors: {
      required: 'This field is required.',
      email: 'Enter a valid email address.',
      phone: 'Enter a valid phone number.',
    },
    successTitle: 'THANK YOU.',
    successBody: "We've received your request. We'll be in touch.",
    errorGeneric: 'Something went wrong while sending. Please try again.',
    again: 'SEND ANOTHER REQUEST',
    serviceOptions: [
      { value: 'lawn-care', label: 'Lawn Care' },
      { value: 'landscaping-yard-maintenance', label: 'Landscaping & Yard Maintenance' },
      { value: 'gutter-cleaning', label: 'Gutter Cleaning' },
      { value: 'window-cleaning', label: 'Window Cleaning' },
      { value: 'bin-cleaning', label: 'Garbage Bin Cleaning' },
      { value: 'seasonal-care', label: 'Seasonal Property Care' },
      { value: 'yard-opening-closing', label: 'Yard Opening / Closing (Seasonal)' },
      { value: 'multiple', label: 'Multiple Services' },
      { value: 'other', label: 'Other' },
    ],
    frequencyOptions: [
      { value: 'one-time', label: 'One-time' },
      { value: 'recurring', label: 'Recurring' },
      { value: 'not-sure', label: 'Not sure' },
    ],
  },
  aboutPage: {
    eyebrow: 'ABOUT DELUXE',
    line1: 'BUILT TO DO',
    line2: 'THE WORK RIGHT.',
    p1: "DELUXE is a local property-services business built around a simple idea: homeowners shouldn't have to spend their free time worrying about the work around their property.",
    p2: "We're starting with the essential outdoor services homeowners need and building toward a broader, premium property-care company that can serve customers throughout the year.",
    whyEyebrow: 'WHY DELUXE?',
    whyHeading: 'THREE THINGS WE CARE ABOUT.',
    principles: [
      { n: '01', title: 'SIMPLE', text: 'No unnecessary complexity.' },
      { n: '02', title: 'PROFESSIONAL', text: 'A clean, organized experience from quote to completed work.' },
      { n: '03', title: 'HARDWORKING', text: 'We understand that good property care starts with being willing to do the work.' },
    ],
    teamTitle: 'THE PEOPLE BEHIND DELUXE',
    teamBody: 'Founder and team information will be added here as the company grows.',
    alt: 'Modern Quebec home with a clean, landscaped front yard',
  },
  footer: {
    tagline: 'Professional property care, done Deluxe.',
    navigate: 'Navigate',
    services: 'Services',
    contact: 'Contact',
    socialSoon: 'Coming soon',
    rights: '© 2026 DELUXE. All rights reserved.',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    location: 'Montreal • Laval • North Shore • Laurentians',
  },
  legal: {
    privacy: {
      title: 'PRIVACY POLICY',
      updated: 'Last updated: 2026',
      sections: [
        { h: 'Overview', p: 'DELUXE ("we", "our") respects your privacy. This policy explains what information we collect through this website, why we collect it, and how it is handled. It is intended to comply with the applicable privacy laws of Quebec, including the Act respecting the protection of personal information in the private sector.' },
        { h: 'Information We Collect', p: 'When you submit a quote request, we collect the information you provide: your name, phone number, email address, property address, the service and frequency you select, and any message you include. We do not collect payment information on this website.' },
        { h: 'How We Use It', p: 'We use this information only to respond to your request, prepare a quote, plan and deliver services, and communicate with you about your property. We do not sell your personal information.' },
        { h: 'Retention & Security', p: 'Quote requests are stored securely and kept only as long as needed to handle your request and manage our business relationship. Access is limited to the people who need it to respond to you.' },
        { h: 'Your Rights', p: 'Under Quebec law, you may request access to the personal information we hold about you, ask for it to be corrected, or ask for it to be deleted. To make a request, contact us at deluxeentretien@gmail.com.' },
        { h: 'Changes', p: 'This policy may be updated as the business grows. The current version will always be available on this page.' },
      ],
    },
    terms: {
      title: 'TERMS OF SERVICE',
      updated: 'Last updated: 2026',
      sections: [
        { h: 'The Service', p: 'DELUXE provides residential property services such as lawn care, landscaping and yard maintenance, gutter cleaning, window cleaning, garbage bin cleaning, and seasonal property care. Service availability may vary by season and location.' },
        { h: 'Quotes', p: 'Submitting a quote request does not create a contract. Quotes are prepared based on the information you provide and confirmed with you before any work begins. The exact scope of each job is agreed upon in advance.' },
        { h: 'Scheduling', p: 'Service dates are confirmed directly with you. Weather and seasonal conditions in Quebec may affect scheduling for outdoor work; we will communicate any changes as early as possible.' },
        { h: 'Your Property', p: 'You are responsible for providing accurate information about your property and for ensuring reasonable access to the areas where work is to be performed.' },
        { h: 'Website Content', p: 'The content of this website is provided for general information. It may be updated at any time without notice. Nothing on this site constitutes a binding offer until confirmed directly by DELUXE.' },
        { h: 'Governing Law', p: 'These terms are governed by the laws applicable in the province of Quebec, Canada.' },
      ],
    },
  },
  admin: {
    title: 'QUOTE REQUESTS',
    loginHeading: 'ADMIN ACCESS',
    loginSub: 'Private area for DELUXE ENTERPRISE.',
    email: 'Email',
    password: 'Password',
    signIn: 'SIGN IN',
    signingIn: 'SIGNING IN…',
    wrong: 'Incorrect email or password.',
    locked: 'Too many attempts. Please try again later.',
    logout: 'LOG OUT',
    total: 'Total',
    newLabel: 'New',
    contacted: 'Contacted',
    completed: 'Completed',
    empty: 'No quote requests yet.',
    emptySub: 'New requests from the website will appear here.',
    markContacted: 'MARK CONTACTED',
    markCompleted: 'MARK COMPLETED',
    delete: 'Delete',
    confirmDelete: 'Delete this quote request? This cannot be undone.',
    backToSite: '← Back to site',
    received: 'Received',
    loadError: 'Could not load requests. Please sign in again.',
  },
  seo: {
    home: { title: 'DELUXE | Landscaping & Property Services in Quebec', desc: 'DELUXE provides professional landscaping, lawn care, and seasonal property services for homeowners in Montreal, Laval, the North Shore, and the Laurentians. Request a quote today.' },
    services: { title: 'Services | DELUXE ENTERPRISE Property Services', desc: 'Lawn care, landscaping and yard maintenance, gutter cleaning, window cleaning, bin cleaning, and seasonal property care in Montreal, Laval, the North Shore, and the Laurentians.' },
    about: { title: 'About | DELUXE ENTERPRISE Property Services', desc: 'DELUXE is a local Quebec property-services company built around simple, professional, hardworking property care.' },
    seasonal: { title: 'Seasonal Services | DELUXE ENTERPRISE Property Services', desc: 'One property, every season. Spring, summer, fall, and winter property care in Montreal, Laval, the North Shore, and the Laurentians.' },
    contact: { title: 'Get a Free Quote | DELUXE ENTERPRISE Property Services', desc: "Tell us what your property needs and we'll get back to you. Request a free quote from DELUXE." },
    privacy: { title: 'Privacy Policy | DELUXE ENTERPRISE', desc: 'How DELUXE collects, uses, and protects your personal information.' },
    terms: { title: 'Terms of Service | DELUXE ENTERPRISE', desc: 'The terms that govern the use of the DELUXE website and services.' },
  },
};
